import { API } from 'core';
import { ServerRoute } from 'core/api';

export class ReportService {
  public static async getReportsByWorkspaceId(workspaceId: string): Promise<void> {
    const route: ServerRoute = ServerRoute.forAction('reports', workspaceId);
    return API.get(route);
  }
}
